<template>
  <div class="hospital-selector-card">
    <img
      v-if="!thisHospital.nonTwiage"
      class="hospital-selector-card__twiage-logo"
      src="@/App/assets/logo.png"
      data-test-id="hospital-selector-icon"
    />
    <img
      v-if="thisHospital.nonTwiage && thisHospital.edPhoneNumbers.length > 0"
      class="hospital-selector-card__phone"
      src="@/App/assets/greenPhone.svg"
      data-test-id="hospital-selector-phone-icon"
    />
    <div class="hospital-selector-card__name" data-test-id="hospital-selector-card__name">
      <span v-if="thisHospital.nonTwiage && thisHospital.edPhoneNumbers.length === 0" class="non-twiage"> &nbsp; </span>
      {{ thisHospital.name }}
      <section v-if="thisHospital.activeStatuses" class="hospital-statuses">
        <b-badge
          v-for="status in thisHospital.activeStatuses.filter((s) => s.priority == 'critical')"
          :key="status.id"
          variant="danger"
        >
          {{ status.status }}
        </b-badge>
        <b-badge
          v-for="status in thisHospital.activeStatuses.filter((s) => s.priority == 'urgent')"
          :key="status.id"
          variant="warning"
        >
          {{ status.status }}
        </b-badge>
      </section>
      <span
        v-if="thisHospital.nonTwiage && thisHospital.edPhoneNumbers.length > 0"
        class="non-twiage-hospital-subtext"
        data-test-id="hospital-selector-non-twiage-subtext"
      >
        <br />
        Call only. No case data will be sent.
      </span>
      <span
        v-if="thisHospital.nonTwiage && thisHospital.edPhoneNumbers.length === 0"
        class="non-twiage-hospital-subtext"
        data-test-id="hospital-selector-non-twiage-subtext"
      >
        <br />
        <span class="non-twiage">&nbsp;</span>No case data will be sent.
      </span>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: "HospitalCard",
  props: {
    thisHospital: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {};
  },

  computed: {},

  methods: {},
};
</script>

<style scoped>
.hospital-selector-card {
  align-items: center;
  background-color: #222222;
  border-radius: 6px;
  display: flex;
  margin-bottom: 1rem;
  padding: 1rem;
}

.hospital-selector-card:last-of-type {
  margin-bottom: 0.5rem;
}

.hospital-selector-card__twiage-logo {
  height: 40px;
}

.hospital-selector-card__phone {
  height: 30px;
  margin-left: 10px;
  margin-right: 24px;
}

.hospital-selector-card__name {
  color: #dddddd;
  font-weight: bold;
  padding-left: 5px;
}
.non-twiage {
  margin-right: 60px;
}

.non-twiage-hospital-subtext {
  font-size: 75%;
  font-weight: normal;
  color: grey;
}
.hospital-statuses span {
  margin-right: 5px;
}
</style>
